import { defineMessages } from 'react-intl-next';

export const messages: {
	searchDialogAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendationsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendedHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchResultsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userShardHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchDialogAriaLabel: {
		id: 'search_dialog_aria_label',
		defaultMessage: 'Search Dialog',
		description: 'aria-label for search dialog container',
	},
	recentsHeading: {
		id: 'search_dialog_recents_heading',
		defaultMessage: 'Recent',
		description: 'Heading for recents section',
	},
	recommendationsHeading: {
		id: 'search_dialog_recommendations_heading',
		defaultMessage: 'Recommendations',
		description: 'Heading for recommendations section',
	},
	recommendedHeading: {
		id: 'search_dialog_recommended_heading',
		defaultMessage: 'Recommended',
		description: 'Heading for recommended section in zero query allocation experiment',
	},
	searchResultsHeading: {
		id: 'recents_heading',
		defaultMessage: 'Search Results',
		description: 'Heading for search results section',
	},
	userShardHeading: {
		id: 'your_recent_results_heading',
		defaultMessage: 'Your recent results',
		description: 'User shard UX heading for search results.',
	},
});
